import { makeStyles, tokens } from "@fluentui/react-components";

export const useRowStyles = makeStyles({
  baseRow: {
    "--row-accent-shadow": "none",
    borderRadius: tokens.borderRadiusMedium,
    transition:
      "background-color 160ms ease, color 160ms ease, box-shadow 160ms ease, transform 120ms ease",
    boxShadow: "var(--row-accent-shadow)",

    ":hover": {
      backgroundImage:
        "linear-gradient(rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.06))",
    },
    "@media (prefers-color-scheme: dark)": {
      ":hover": {
        backgroundImage:
          "linear-gradient(rgba(0, 0, 0, 0.12), rgba(0, 0, 0, 0.12))",
      },
    },

    ":focus-visible": {
      outlineStyle: "solid",
      outlineColor: tokens.colorStrokeFocus1,
      outlineWidth: tokens.strokeWidthThick,
      outlineOffset: "2px",
    },
  },

  scheduledRow: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
    "--row-accent-shadow": `inset 4px 0 0 0 ${tokens.colorNeutralStroke1}`,
    backgroundImage: "none",
  },

  onTimeRow: {
    // backgroundColor: tokens.colorStatusSuccessBackground2,
    // color: tokens.colorStatusSuccessForeground2,
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground1,
    "--row-accent-shadow": `inset 4px 0 0 0 ${tokens.colorStatusSuccessForeground1}`,
  },

  delayedRow: {
    backgroundColor: tokens.colorPaletteYellowBackground2,
    color: tokens.colorPaletteDarkRedForeground2,
    "--row-accent-shadow": "inset 4px 0 0 0 #ffbe0b",
  },

  cancelledRow: {
    backgroundColor: tokens.colorStatusDangerBackground2,
    color: tokens.colorStatusDangerForeground1,
    "--row-accent-shadow": `inset 4px 0 0 0 ${tokens.colorStatusDangerForeground1}`,
    backgroundImage: "none",
  },

  selectedRow: {
    outline: `${tokens.strokeWidthThick} solid ${tokens.colorNeutralForeground2Selected}`,
    outlineOffset: "-2px", // pulls the outline inward a bit
    transform: "translateY(-0.5px)",
    border: "none",
  },
});
